import axios from "axios";

const API_BASE_URL = "https://dbskillsattendance.iilos.org/api";
// const API_BASE_URL = "http://localhost:6001/api";


const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  // timeout: 10000,
});

// Random id generated once per browser install and kept in localStorage.
const getDeviceId = () => {
  try {
    let id = localStorage.getItem("deviceId");
    if (!id) {
      id =
        window.crypto && window.crypto.randomUUID
          ? window.crypto.randomUUID()
          : `web-${Date.now()}-${Math.random().toString(36).slice(2, 12)}`;
      localStorage.setItem("deviceId", id);
    }
    return id;
  } catch (e) {
    return null;
  }
};

// ✅ Add token automatically
axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  const deviceId = getDeviceId();
  if (deviceId) {
    config.headers["x-device-id"] = deviceId;
    config.headers["x-device-model"] = (navigator.userAgent || "").slice(0, 120);
    config.headers["x-device-platform"] = "web";
  }

  return config;
});

export const getServerTimeApi = async () => {
  const response = await axiosInstance.get("/attendance/server-time");
  return response.data;
};

export default axiosInstance;